import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const modalsStateSelector = (state: RootState) => state.modals;

export const selectorOpenModal = createSelector(
	modalsStateSelector,
	(state) => state.currentModal,
);
